import { Box } from "@chakra-ui/react"

export const overlayStyles = {
  pos: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  minHeight: "100%",
  minWidth: "100%",
  overflow: "hidden"
} as const

const DotBackground = ({ dotSize = 4, dotSpacing = 20 }) => (
  <Box borderRadius="inherit" {...overlayStyles}>
    {/* Gradient Overlay */}
    <Box
      {...overlayStyles}
      borderRadius="inherit"
      bgGradient="linear(to-b, rgba(51, 49, 50, 0.5) 0%, rgba(51, 49, 50, 0.8) 100%)"
    />

    {/* Dots Pattern */}
    <Box
      {...overlayStyles}
      borderRadius="inherit"
      bgImage={`radial-gradient(rgba(255, 255, 255, 0.2) ${
        (dotSize / dotSpacing) * 100
      }%, transparent ${(dotSize / dotSpacing) * 100}%)`}
      bgPosition={`0 0, ${dotSpacing / 2}px ${dotSpacing / 2}px`}
      bgSize={`${dotSpacing}px ${dotSpacing}px`}
    />
  </Box>
)

export default DotBackground
